import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-09218f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white edit-composition-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date de composition "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date limite de soumission "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Filière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Matière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Professeur "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Année Académique "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "form-group mb-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Type de composition "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "form-check me-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fw-medium",
  for: "qcmRadio"
}, "QCM", -1))
const _hoisted_36 = { class: "form-check" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fw-medium",
  for: "qrRadio"
}, "Questions/Réponses", -1))
const _hoisted_38 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "border border-primary mb-10" }
const _hoisted_41 = { class: "row d-flex align-items-center justify-content-between fw-bold py-3 bg-primary" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7 ps-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white mb-0" }, "QCM")
], -1))
const _hoisted_43 = { class: "col-md-5 pe-4" }
const _hoisted_44 = {
  key: 0,
  class: "badge bg-light text-primary fs-6 float-end"
}
const _hoisted_45 = { class: "p-4" }
const _hoisted_46 = { class: "form-group mb-15" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Sélectionner les questions "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_48 = {
  key: 1,
  class: "row mt-4"
}
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = { class: "border border-primary mb-10" }
const _hoisted_51 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7 ps-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white" }, "Ajouter les questions")
], -1))
const _hoisted_53 = { class: "col-md-5 pe-3" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1" }, null, -1))
const _hoisted_55 = { class: "p-4" }
const _hoisted_56 = { class: "row mt-3 align-items-start" }
const _hoisted_57 = { class: "col-md-6" }
const _hoisted_58 = { class: "d-block text-black fw-semibold mb-2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1))
const _hoisted_60 = ["onUpdate:modelValue"]
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Réponse", -1))
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = { class: "col-md-2 d-flex align-items-start pt-4" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1))
const _hoisted_67 = { class: "row mt-4" }
const _hoisted_68 = { class: "col-md-12" }
const _hoisted_69 = { class: "d-flex align-items-center" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "compositionForm",
        onSubmit: _ctx.editComposition,
        onInvalidSubmit: _ctx.handleInvalidSubmit,
        "validation-schema": _ctx.compositionSchema,
        validateOnInput: false,
        validateOnMount: false,
        initialValues: {
          titre: _ctx.titre,
          dateComposition: _ctx.dateComposition,
          dateFinSoumission: _ctx.dateFinSoumission,
          professeur: _ctx.selectedProfesseur,
          niveau: _ctx.selectedNiveau,
          matiere: _ctx.selectedMatiere,
          filiere: _ctx.selectedFiliere,
          anneeAcademique: _ctx.selectedAnneeAcademique,
          typeComposition: _ctx.typeComposition,
          questions: _ctx.selectedQuestions,
          questionsAdded: _ctx.addedQuestions
        }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "titre",
                  type: "text",
                  modelValue: _ctx.titre,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.titre) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le titre"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "titre",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  name: "dateComposition",
                  type: "date",
                  modelValue: _ctx.dateComposition,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateComposition) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateComposition",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  name: "dateFinSoumission",
                  type: "date",
                  modelValue: _ctx.dateFinSoumission,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateFinSoumission) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateFinSoumission",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, { name: "niveau" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.niveauxOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onNiveauChange,
                      placeholder: "Sélectionner le niveau"
                    }), null, 16, ["options", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "niveau",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, { name: "filiere" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.filieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onFiliereChange,
                      placeholder: "Sélectionner la filière",
                      disabled: !_ctx.selectedNiveau || _ctx.isLoadingFilieres
                    }), null, 16, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "filiere",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_Field, { name: "matiere" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.matieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onMatiereChange,
                      placeholder: "Sélectionner la matière",
                      disabled: !_ctx.selectedNiveau || !_ctx.selectedFiliere || _ctx.isLoadingMatieres
                    }), null, 16, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "matiere",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_Field, { name: "professeur" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.currentProfesseursOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label"
                    }, field, {
                      placeholder: "Sélectionner le professeur",
                      disabled: !_ctx.selectedMatiere || !_ctx.currentProfesseursOptions.length
                    }), null, 16, ["options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "professeur",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_Field, { name: "anneeAcademique" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.anneesAcademiquesOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner l'année académique" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "anneeAcademique",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_Field, {
                      name: "typeComposition",
                      type: "radio",
                      value: "QCM",
                      id: "qcmRadio",
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleTypeChange('QCM'))),
                      class: "form-check-input me-2"
                    }),
                    _hoisted_35
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_Field, {
                      name: "typeComposition",
                      type: "radio",
                      value: "QuestionsReponses",
                      id: "qrRadio",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleTypeChange('QuestionsReponses'))),
                      class: "form-check-input me-2"
                    }),
                    _hoisted_37
                  ])
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "typeComposition",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          (_ctx.typeComposition === 'QCM')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        (_ctx.selectedQuestions.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.selectedQuestions.length) + " question(s) sélectionnée(s) ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createVNode(_component_Field, { name: "questions" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.questionsOptions,
                              searchable: true,
                              multiple: "true",
                              mode: "tags",
                              "track-by": "label",
                              label: "label",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              onChange: _ctx.onQCMQuestionsChange,
                              placeholder: "Sélectionner les questions"
                            }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "questions",
                          class: "text-danger"
                        })
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.typeComposition === 'QuestionsReponses')
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _hoisted_52,
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("button", {
                          class: "btn btn-success float-end",
                          type: "button",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addNewQuestion && _ctx.addNewQuestion(...args)))
                        }, [
                          _hoisted_54,
                          _createTextVNode(" Ajouter une question ")
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedQuestions, (question, index) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: question.tempId
                        }, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("label", _hoisted_58, [
                                _createTextVNode(" Question " + _toDisplayString(index + 1) + " ", 1),
                                _hoisted_59
                              ]),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": ($event: any) => ((question.contenu) = $event),
                                class: "form-control shadow-none text-black",
                                placeholder: "Entrer le contenu de la question",
                                rows: "3"
                              }, null, 8, _hoisted_60), [
                                [_vModelText, question.contenu]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": ($event: any) => ((question.reponse) = $event),
                                class: "form-control shadow-none text-black",
                                placeholder: "Entrer la réponse (optionnel)",
                                rows: "3"
                              }, null, 8, _hoisted_63), [
                                [_vModelText, question.reponse]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              (_ctx.addedQuestions.filter(q => !q.toDelete).length > 1)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-danger btn-sm",
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.removeQuestion(index))
                                  }, " Supprimer ", 8, _hoisted_65))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])), [
                          [_vShow, !question.toDelete]
                        ])
                      }), 128))
                    ]),
                    _hoisted_66
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_71))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Modification...' : 'Modifier la composition'), 1)
                ], 8, _hoisted_70),
                _createVNode(_component_router_link, {
                  to: "/liste-compositions",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_72,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit", "validation-schema", "initialValues"])
    ])
  ]))
}